exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".permits .filter-checkbox .vue-treeselect,.permits .filter-select .nice-select.better-select{border:3px solid #13293e}.permits .filter-select .nice-select.better-select span{color:#13293e}.permits .demo-date input{background:transparent;border:3px solid #13293e;border-radius:10px;font-size:1.2rem;color:#000;padding:10px;height:50px;margin:10px 0;width:100%}.permits .demo-date.mx-datepicker.mx-datepicker-range{width:100%;margin:0 10px}", ""]);

// exports
